import styled from 'styled-components'
import { Polygon_STATICS } from '../../static'
import Logo from '../common/Logo'
// import useEnvConfig from 'hooks/useEnvConfig'

export default function Footer() {
  // const { CHAIN_ID } = useEnvConfig()
  return (
    <FooterWrapper>
      <FooterContent>
        <Logo />
        <Links />
        <SocialList />
      </FooterContent>
    </FooterWrapper>
  )
}

const FooterWrapper = styled.div`
  height: 100px;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1);
`

const FooterContent = styled.div`
  width: 1400px;
  height: 100%;
  margin: 0 auto;
  padding: 0 88px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`

const socials = [
  {
    icon: Polygon_STATICS.Polygon_twitter,
    url: 'https://twitter.com/combonetworkio',
  },
  {
    icon: Polygon_STATICS.Polygon_github,
    url: 'https://github.com/cocos-bcx',
  },
  {
    icon: Polygon_STATICS.Polygon_discord,
    url: 'https://discord.gg/MtSDsjJDR8',
  },
  {
    icon: Polygon_STATICS.Polygon_tele,
    url: 'https://t.me/COMBONetworkio',
  },
  {
    icon: Polygon_STATICS.Polygon_medium,
    url: 'https://medium.com/combonetwork',
  },
]

function SocialList() {
  return (
    <SocialListWrapper>
      {socials.map((social) => (
        <a key={social.url} rel="noreferrer" href={social.url} target={'_blank'}>
          <img alt={'icon'} src={social.icon} />
        </a>
      ))}
    </SocialListWrapper>
  )
}

const SocialListWrapper = styled.div`
  width: 286px;
  height: 32px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  a {
    margin-left: 14px;
  }
  img {
    width: 32px;
    height: 32px;
  }
`

function Links() {
  return (
    <LinksWrapper>
      <a href="/">Copyright © 2018-2022 Cocos-BCX. All Rights Reserved.</a>
      <a href="mailto:Support@cocosbcx.io">Email: Support@cocosbcx.io</a>
    </LinksWrapper>
  )
}

const LinksWrapper = styled.div`
  width: 654px;
  height: 20px;
  a {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
    outline: none;
    text-decoration: none;
    &:last-child {
      margin-left: 32px;
    }
  }
  position: absolute;
  left: 425px;
  top: 39px;
`
